 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"polyfills-core-js":"polyfills-core-js","polyfills-dom":"polyfills-dom","stencil-polyfills-css-shim":"stencil-polyfills-css-shim","stencil-polyfills-dom":"stencil-polyfills-dom"}[chunkId]||chunkId) + "." + {"chunk-02c995b5":"6f6b7847","chunk-09155df3":"f4be8470","chunk-09162720":"f7d5f7e9","chunk-097e0872":"2eba7766","chunk-0a4d4e4c":"ea54e314","chunk-0b9fd0dc":"4697bc9f","chunk-0d1af90a":"33c16356","chunk-0e93a01c":"db5e0968","chunk-106fab1a":"e4665dee","chunk-15fecba3":"12f6704d","chunk-1bc223c0":"c897ae00","chunk-1bff95de":"8e2a18dd","chunk-1dbc15a2":"cd7890b5","chunk-21a76241":"79ca4195","chunk-25d83ca8":"9537e4de","chunk-2d0a463b":"3a71dd05","chunk-2d0ac931":"667708a1","chunk-2d0be333":"298b7986","chunk-466a0a3c":"a3f6ba63","chunk-02e7c245":"0403650a","chunk-12ad372d":"61004251","chunk-46d991a1":"d31e9405","chunk-56afa801":"8429166d","chunk-727d8ed9":"75791d50","chunk-16ccaa03":"26be32a5","chunk-06519618":"a2ce09b4","chunk-216a5e8a":"3385531c","chunk-2566dd65":"ae650c55","chunk-25aa3d80":"7de8bcc0","chunk-26aeabb3":"96259849","chunk-2bf92c1c":"faa26be7","chunk-2d0af2b6":"01b9f59e","chunk-2d21f268":"c6ed6fde","chunk-481c2f3f":"effa6996","chunk-48690f2e":"796fe548","chunk-50199ff8":"27de94dc","chunk-508c774f":"fad71f50","chunk-2e079fb4":"8862476c","chunk-3bc2fb0f":"92279730","chunk-4900abf6":"cbbcefe6","chunk-ac089190":"e57474dc","chunk-bcc53ea2":"e4308b4d","chunk-fddeed58":"d34424e4","chunk-5d6c8186":"9813085f","chunk-79c400c4":"e10c8881","chunk-7a22c0c8":"18ba0488","chunk-2d0d05bd":"7fc23bb6","chunk-a4269fb0":"11f1029b","chunk-ac7b6024":"69024d46","chunk-b3712526":"fd72eb9f","chunk-b7ba04f4":"4ebdcfb5","chunk-ce4d1750":"5c53e68c","chunk-f40aaa84":"b8fd8bb0","chunk-fcebc0bc":"80863aec","chunk-1ef6cfdd":"5cb44ab5","chunk-2545c3e2":"c4cb3873","chunk-2d0c073f":"50e276e1","chunk-2d0c211b":"bd5d9530","chunk-2d0c820a":"c5f50485","chunk-2d0ce848":"80c01748","chunk-2d0cf0e0":"28d5d1fa","chunk-2d0cf315":"8bdd27d5","chunk-2d0d2ed3":"2d9c3d4b","chunk-2d0d43da":"b14f9e1d","chunk-2d0da04a":"50e3fbb9","chunk-2d0e5812":"c5dde327","chunk-2d210fa0":"af243eb0","chunk-2d213189":"37da8e05","chunk-2d217def":"a644b19b","chunk-2d217e6a":"9d5e5387","chunk-2d218068":"df48bc72","chunk-2d21a9aa":"51f415cb","chunk-2d21da73":"af357877","chunk-2d222cca":"eaa1fa6a","chunk-2d22895d":"77161f63","chunk-2d2304d2":"e5c3a3b9","chunk-2d23721e":"013295b1","chunk-2d237b00":"17ee064a","chunk-2e7c70ac":"fdf9b4d7","chunk-30dd9750":"788615dc","chunk-35c0796a":"cff96420","chunk-37f2300e":"e713389c","chunk-3d04411e":"ed5a702b","chunk-3ed29de3":"4c64fae7","chunk-41c0f7a4":"62b0fe49","chunk-425693df":"5ba9529e","chunk-43a986e1":"3cd69e3f","chunk-462c869e":"8dad98af","chunk-47245a33":"ca01aa9b","chunk-4739acd0":"b9e18e52","chunk-479cc521":"c04443df","chunk-485adc83":"3e74aa9c","chunk-4f008560":"3eb637c4","chunk-4fd626e4":"fa06ebc0","chunk-53b1137a":"4ab16304","chunk-541ea42d":"b15c34a8","chunk-54bbd082":"d56971d5","chunk-59d4c87c":"4b4143d8","chunk-5a8ac886":"39826562","chunk-5ff96a24":"4b870618","chunk-69eb8776":"8a408dfe","chunk-6cd7c166":"7cf904f3","chunk-6d375f34":"31f7582d","chunk-144ab49c":"4e113018","chunk-67756ca8":"f43b6835","chunk-a0d3ba90":"12b04d6f","chunk-7548ca2d":"50735db0","chunk-79f1dac7":"03ae9d81","chunk-7dcbdd14":"2b087d8f","chunk-8bb7f81e":"8fbabf68","chunk-95de8b54":"b3b52e36","chunk-9b6a039a":"91f08b56","chunk-a9395c36":"26f1dbf5","chunk-b6264d86":"5dc02022","chunk-bdaf819c":"be0be1d3","chunk-c4066ff2":"21da3bf6","chunk-c5a303d6":"7c188f18","chunk-c5ab9800":"98d4d4aa","chunk-d0e8aa0a":"5c64e092","chunk-d8413eac":"81581aaa","chunk-de0319e8":"10ea9c97","chunk-e5275ddc":"bcc34298","chunk-eaa2b130":"072cdf8a","chunk-f55d7928":"2f662d93","chunk-fbd9b524":"6116554b","polyfills-core-js":"098e4033","polyfills-dom":"662760da","stencil-polyfills-css-shim":"95cbdafc","stencil-polyfills-dom":"f9377d9e","chunk-2d2297f7":"52f02239","chunk-2d2073d6":"9e36930f","chunk-2d0b33e3":"2e69defc","chunk-2d0b9280":"199a57da","chunk-2d0baac9":"ecbd8a2b","chunk-2d21a589":"3dace732","chunk-2d2376e6":"a05b70ee"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-0a4d4e4c":1,"chunk-0b9fd0dc":1,"chunk-0d1af90a":1,"chunk-15fecba3":1,"chunk-466a0a3c":1,"chunk-02e7c245":1,"chunk-12ad372d":1,"chunk-46d991a1":1,"chunk-56afa801":1,"chunk-16ccaa03":1,"chunk-06519618":1,"chunk-216a5e8a":1,"chunk-2566dd65":1,"chunk-25aa3d80":1,"chunk-26aeabb3":1,"chunk-2bf92c1c":1,"chunk-481c2f3f":1,"chunk-48690f2e":1,"chunk-508c774f":1,"chunk-2e079fb4":1,"chunk-3bc2fb0f":1,"chunk-4900abf6":1,"chunk-ac089190":1,"chunk-bcc53ea2":1,"chunk-fddeed58":1,"chunk-5d6c8186":1,"chunk-79c400c4":1,"chunk-7a22c0c8":1,"chunk-a4269fb0":1,"chunk-ac7b6024":1,"chunk-b3712526":1,"chunk-b7ba04f4":1,"chunk-ce4d1750":1,"chunk-f40aaa84":1,"chunk-fcebc0bc":1,"chunk-1ef6cfdd":1,"chunk-2545c3e2":1,"chunk-2e7c70ac":1,"chunk-35c0796a":1,"chunk-3d04411e":1,"chunk-425693df":1,"chunk-43a986e1":1,"chunk-479cc521":1,"chunk-4f008560":1,"chunk-4fd626e4":1,"chunk-6cd7c166":1,"chunk-144ab49c":1,"chunk-67756ca8":1,"chunk-a0d3ba90":1,"chunk-7dcbdd14":1,"chunk-95de8b54":1,"chunk-9b6a039a":1,"chunk-b6264d86":1,"chunk-bdaf819c":1,"chunk-c4066ff2":1,"chunk-c5a303d6":1,"chunk-c5ab9800":1,"chunk-de0319e8":1,"chunk-f55d7928":1,"chunk-fbd9b524":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"polyfills-core-js":"polyfills-core-js","polyfills-dom":"polyfills-dom","stencil-polyfills-css-shim":"stencil-polyfills-css-shim","stencil-polyfills-dom":"stencil-polyfills-dom"}[chunkId]||chunkId) + "." + {"chunk-02c995b5":"31d6cfe0","chunk-09155df3":"31d6cfe0","chunk-09162720":"31d6cfe0","chunk-097e0872":"31d6cfe0","chunk-0a4d4e4c":"156374f6","chunk-0b9fd0dc":"fb51979b","chunk-0d1af90a":"1c3ac598","chunk-0e93a01c":"31d6cfe0","chunk-106fab1a":"31d6cfe0","chunk-15fecba3":"e3c5874f","chunk-1bc223c0":"31d6cfe0","chunk-1bff95de":"31d6cfe0","chunk-1dbc15a2":"31d6cfe0","chunk-21a76241":"31d6cfe0","chunk-25d83ca8":"31d6cfe0","chunk-2d0a463b":"31d6cfe0","chunk-2d0ac931":"31d6cfe0","chunk-2d0be333":"31d6cfe0","chunk-466a0a3c":"00c69e06","chunk-02e7c245":"618ad098","chunk-12ad372d":"986ce0f9","chunk-46d991a1":"d39f463e","chunk-56afa801":"5529b852","chunk-727d8ed9":"31d6cfe0","chunk-16ccaa03":"fbce7129","chunk-06519618":"dd75e3c9","chunk-216a5e8a":"7ffc626a","chunk-2566dd65":"55d57720","chunk-25aa3d80":"5b6f8060","chunk-26aeabb3":"983f367e","chunk-2bf92c1c":"526c91d0","chunk-2d0af2b6":"31d6cfe0","chunk-2d21f268":"31d6cfe0","chunk-481c2f3f":"1582def1","chunk-48690f2e":"009c578a","chunk-50199ff8":"31d6cfe0","chunk-508c774f":"32421b7c","chunk-2e079fb4":"a05901e3","chunk-3bc2fb0f":"8e25387d","chunk-4900abf6":"4bb04f79","chunk-ac089190":"47ec33af","chunk-bcc53ea2":"ea0c46e4","chunk-fddeed58":"d03be21c","chunk-5d6c8186":"41f68275","chunk-79c400c4":"dc03a62a","chunk-7a22c0c8":"0185c038","chunk-2d0d05bd":"31d6cfe0","chunk-a4269fb0":"19e67be8","chunk-ac7b6024":"4364a1d1","chunk-b3712526":"ad64b4b4","chunk-b7ba04f4":"f51b2390","chunk-ce4d1750":"cd643b49","chunk-f40aaa84":"a7516eb4","chunk-fcebc0bc":"0696c441","chunk-1ef6cfdd":"070cac1b","chunk-2545c3e2":"7b57876b","chunk-2d0c073f":"31d6cfe0","chunk-2d0c211b":"31d6cfe0","chunk-2d0c820a":"31d6cfe0","chunk-2d0ce848":"31d6cfe0","chunk-2d0cf0e0":"31d6cfe0","chunk-2d0cf315":"31d6cfe0","chunk-2d0d2ed3":"31d6cfe0","chunk-2d0d43da":"31d6cfe0","chunk-2d0da04a":"31d6cfe0","chunk-2d0e5812":"31d6cfe0","chunk-2d210fa0":"31d6cfe0","chunk-2d213189":"31d6cfe0","chunk-2d217def":"31d6cfe0","chunk-2d217e6a":"31d6cfe0","chunk-2d218068":"31d6cfe0","chunk-2d21a9aa":"31d6cfe0","chunk-2d21da73":"31d6cfe0","chunk-2d222cca":"31d6cfe0","chunk-2d22895d":"31d6cfe0","chunk-2d2304d2":"31d6cfe0","chunk-2d23721e":"31d6cfe0","chunk-2d237b00":"31d6cfe0","chunk-2e7c70ac":"c145749e","chunk-30dd9750":"31d6cfe0","chunk-35c0796a":"71e1d874","chunk-37f2300e":"31d6cfe0","chunk-3d04411e":"6e4addac","chunk-3ed29de3":"31d6cfe0","chunk-41c0f7a4":"31d6cfe0","chunk-425693df":"73a4a3f6","chunk-43a986e1":"0a5a6018","chunk-462c869e":"31d6cfe0","chunk-47245a33":"31d6cfe0","chunk-4739acd0":"31d6cfe0","chunk-479cc521":"5427e000","chunk-485adc83":"31d6cfe0","chunk-4f008560":"28ff2758","chunk-4fd626e4":"8b928498","chunk-53b1137a":"31d6cfe0","chunk-541ea42d":"31d6cfe0","chunk-54bbd082":"31d6cfe0","chunk-59d4c87c":"31d6cfe0","chunk-5a8ac886":"31d6cfe0","chunk-5ff96a24":"31d6cfe0","chunk-69eb8776":"31d6cfe0","chunk-6cd7c166":"d1af7573","chunk-6d375f34":"31d6cfe0","chunk-144ab49c":"c1c4727a","chunk-67756ca8":"e8479e02","chunk-a0d3ba90":"179fbde4","chunk-7548ca2d":"31d6cfe0","chunk-79f1dac7":"31d6cfe0","chunk-7dcbdd14":"2511e2b9","chunk-8bb7f81e":"31d6cfe0","chunk-95de8b54":"5a6ea588","chunk-9b6a039a":"58918530","chunk-a9395c36":"31d6cfe0","chunk-b6264d86":"dae80a32","chunk-bdaf819c":"c3dd66ab","chunk-c4066ff2":"121da575","chunk-c5a303d6":"7422bfda","chunk-c5ab9800":"9f25a71f","chunk-d0e8aa0a":"31d6cfe0","chunk-d8413eac":"31d6cfe0","chunk-de0319e8":"14d8860f","chunk-e5275ddc":"31d6cfe0","chunk-eaa2b130":"31d6cfe0","chunk-f55d7928":"1e97b90f","chunk-fbd9b524":"0ff64f31","polyfills-core-js":"31d6cfe0","polyfills-dom":"31d6cfe0","stencil-polyfills-css-shim":"31d6cfe0","stencil-polyfills-dom":"31d6cfe0","chunk-2d2297f7":"31d6cfe0","chunk-2d2073d6":"31d6cfe0","chunk-2d0b33e3":"31d6cfe0","chunk-2d0b9280":"31d6cfe0","chunk-2d0baac9":"31d6cfe0","chunk-2d21a589":"31d6cfe0","chunk-2d2376e6":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
